import React, { Component } from "react";

//Import Breadcrumb
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
} from "../../store/functions";
import "./datatables.scss"
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';




class pageList_ItemType  extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      page: 1,
      sizePerPage: 10,
      productData: [],
      isEditing: null,
      
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Item Type";
    this.modalTitle = "Company Details";
    this.rtPage_Add = "AddItemType";
    this.rtPage_Edit = "EditItemType";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/ItemType";
    this.API_URL1 = API_WEB_URLS.MASTER + "/0/token/UpdateRate";
    this.API_URL2 = API_WEB_URLS.MASTER + "/0/token/UpdateRate2";
    this.inputRefs = {};
    this.inputRefs2 = {};

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.saveRate = this.saveRate.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.handleFocus   = this.handleFocus.bind(this);
    this.handleChange  = this.handleChange.bind(this);
  }
  componentDidMount() {

    document.addEventListener("keydown", this.handleKeyDown);
    const obj = JSON.parse(localStorage.getItem("authUser"));
     Fn_FillListData(this.obj, "gridData", this.API_URL + "/Id/0" );
  }

  handleFocus = (rowId,name) => {
    // Focus the input field associated with the given rowId
    if (this.inputRefs[rowId] && name =='Rate1') {
      this.inputRefs[rowId].focus();
    }
    else if (this.inputRefs2[rowId] && name =='Rate2') {
      this.inputRefs2[rowId].focus();
    }
  };

  handleChange = (e, row,name) => {
    const newValue = e.target.value;
    const updatedGridData = this.state.gridData.map((item) =>
      item.Id === row.Id ? { ...item, [name]: newValue } : item
    );

    // Update the gridData in the state
    this.setState({ gridData: updatedGridData }, () => {
      // Ensure the focus is kept after state update
      this.handleFocus(row.Id,name);
    });
  };
  
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  handleKeyDown = event => {
    switch (event.key) {
      case "A":
      case "a":
        event.preventDefault();
        this.btnAdd_onClick();
        break;
      default:
        break;
    }
  };
  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(Id) {
    this.props.history.push(`${this.rtPage_Edit}/${Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }
  saveRate (Id,Rate,name){
    console.log(Id,Rate);
    if(name=='Rate1'){

      Fn_FillListData(this.obj, "nothing", this.API_URL1 + "/"+Rate+"/"+Id );
    }else if(name=='Rate2'){
      Fn_FillListData(this.obj, "nothing", this.API_URL2 + "/"+Rate+"/"+Id );
      
    }
  }
  // renderGridHeader() {
  //   return (
  //     <>
  //       <th>Name</th>
  //       <th>Ledger Group Name</th>
  //       <th>Phone</th>
  //       <th>Email</th>
       
  //     </>
  //   );
  // }
  
  render() {

    const columns = [
      {
      dataField: 'Company',
      text: 'Company',
      sort: true
    },
      {
      dataField: 'ItemName',
      text: 'ItemName',
      sort: true
    },
     {
      dataField: 'Alias',
      text: 'Alias',
      sort: true
    }, 
    
     {
      dataField: 'Rate1',
      text: 'MRP',
      formatter: (cellContent, row) => {
        return (
          <div style={{ position: 'relative' }}>
            <input
              type="number"
              ref={(ef) => { this.inputRefs[row.Id] = ef; }}
              value={this.state.gridData.find(item => item.Id === row.Id)?.Rate1 || ""}
              onChange={(e) => this.handleChange(e, row,'Rate1')}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.saveRate(row.Id, row.Rate1,'Rate1');
                }
              }}
              title="Enter the rate"
              style={{
                width: '60%',
                padding: '8px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = '#80bdff'}
              onBlur={(e) => e.target.style.borderColor = '#ced4da'}
            />
          </div>
        );
      },
    }, 
     {
      dataField: 'Rate2',
      text: 'Net Price',
      formatter: (cellContent, row) => {
        return (
          <div style={{ position: 'relative' }}>
            <input
              type="number"
              ref={(el) => { this.inputRefs2[row.Id] = el; }}
              value={this.state.gridData.find(item => item.Id === row.Id)?.Rate2 || ""}
              onChange={(e) => this.handleChange(e, row,'Rate2')}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.saveRate(row.Id, row.Rate2,'Rate2');
                }
              }}
              title="Enter the rate"
              style={{
                width: '60%',
                padding: '8px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = '#80bdff'}
              onBlur={(e) => e.target.style.borderColor = '#ced4da'}
            />
          </div>
        );
      },
    }, 
    
    {
      dataField: "Edit",
      text: "Edit",
      formatter: (cellContent, row) => {
        return (
          <button
          type="button"
            className="btn btn-warning btn-xs"
            onClick={() => this.btnEdit_onClick(row.Id)}
          >
            Edit
          </button>
        );
      },
    },
    {
      dataField: "Delete",
      text: "Delete",
      formatter: (cellContent, row) => {
        return (
          <button
            type="button"
            className="btn btn-danger btn-xs"
            onClick={() => this.btnDelete_onClick(row)}
          >
            Delete
          </button>
        );
      },
    },
  ];

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.gridData, // replace later with size(customers),
      custom: true,
    }
    const selectRow = {
      mode: 'checkbox'
    }
    const { SearchBar } = Search;


    return (
      <div className="page-content">
                  
                  <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField='id'
                      columns={columns}
                      data={this.state.gridData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='id'
                          columns={columns}
                          data={this.state.gridData}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>

                              <Row className="mb-2">
                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>

                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                    <Button type="button" onClick={this.btnAdd_onClick} color="success" className="btn-rounded waves-effect waves-light mb-2 mr-2"><i className="mdi mdi-plus mr-1"></i> Add New</Button>
                                 
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      selectRow={selectRow}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />

                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )
                          }
                        </ToolkitProvider>
                      )
                      }</PaginationProvider>
      </div>
    );
  }
}
export default compose(container)(pageList_ItemType );